<template>
  <div id="Banks">
    <headNav>
      <div slot="headNavText">{{$t('message.add_bank')}}</div>
    </headNav>
    <div class="container">
      <div class="bascInfoBox">
        <div>
          <div class="circle"></div>
          <div class="circle"></div>
          <div class="circle"></div>
          <div class="circle circle1">04</div>
        </div>
        <div class="scsf">
          <div>{{$t('message.bank_rz')}}</div>
          <div>{{$t('message.bank_rz_tips')}}</div>
        </div>
        <div class="bascInfoContent" style="margin-top: 0.6rem">
<!--          <div class="form_item">-->
<!--            <div class="form_label"><span>*</span>{{$t('message.holdName')}}</div>-->
<!--            <van-field v-model="holdBankPer" readonly/>-->
<!--          </div>-->
<!--          <div class="form_item">-->
<!--            <div class="form_label"><span>*</span>{{$t('message.idcar')}}</div>-->
<!--            <van-field v-model="holdBankIdCard" readonly/>-->
<!--          </div>-->
          <div class="form_item">
            <div class="form_label"><span>*</span>{{$t('message.bankCard')}}</div>
            <van-field v-model="BankId" :placeholder="$t('message.banksAccount')" type="number"/>
          </div>
          <div class="form_item">
            <div class="form_label"><span>*</span>{{$t('message.bankNwes')}}</div>
            <van-field v-model="bankName" :placeholder="$t('message.choose_banks')" right-icon="arrow-down"
                       @focus="showModel" readonly/>
          </div>
          <van-button type="primary" round size="normal" @click="getLoan" class="btns" block>
            {{$t('message.add_com')}}
          </van-button>
        </div>
      </div>
    </div>
    <!--弹出层-->
    <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
      <van-picker :columns='banksArr' @cancel="onCancel" :show-toolbar='true'
                  @confirm="onConfirm" :confirm-button-text="$t('message.determine')"
                  :cancel-button-text="$t('message.cancel')">
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
  import {getBanksNews, sassSearchBanksList, getBanks, postBanks, postRenInfo} from '../../../ports/port'
  import headNav from "../../HeadNav/headNav";

  export default {
    name: "banks",
    data() {
      return {
        show: false,
        holdBankPer: '',//持卡人姓名
        holdBankIdCard: '',//联系人身份证
        bankName: '',//银行卡名称
        BankId: '',//银行卡卡号
        tk: JSON.parse(localStorage.getItem("tokenAll")),
        banksArr: [],
        temp: [],
        showTip: false,
        showLoading: false,
        bankLogo: [],//存放银行logo
        banksList: [],
        //一下是选择银行卡，所需要向后端提供的
        bankID: '',
        accountSupport: '',
        cardSupport: '',
        abbreviation: '',
        isRest: '',//判断是否审核拒绝，需要重新认证
        //以上是选择银行卡，所需要向后端提供的
        total_rz: 0,//需要认证的步数
        has_rz_total: 0//已经认证的步数
      }
    },
    components: {
      headNav,
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      //获取银行卡种类
      getBanks({})
        .then(res => {
          if (res.data.code == 200) {
            let arr = res.data.data;
            this.temp = res.data.data;
            arr.forEach((elem, index) => {
              this.bankLogo.push(elem.photo_url);
              this.banksArr.push({'text': `<img class="cloumns-img" src='${this.bankLogo[index]}'>` + elem.abbreviation});
              this.banksList.push(elem.abbreviation);
            })
          }
        })
        .catch(err => {
          if (err.toString().indexOf('timeout') != -1) {
            this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
          }
        });
      this.holdBankPer = localStorage.getItem('name');
      this.holdBankIdCard = localStorage.getItem('IdCard');

      postRenInfo({userid: this.tk.userid})
        .then(res => {
          //is_true=>1未认证 2已认证   is_display=》1显示 0不显示   is_varify=》1必须认证  0不必须认证
          res.data.data.forEach((e, i) => {
            // 获取总共的认证流程的步数
            this.total_rz++;
            // 统计非运营商步骤总共已经认证的
            if (e.is_true == 2 && e.is_varify == 1 && e.is_display == 1 && e.veriry_desc != '运营商') {
              this.has_rz_total++;
            } else if (e.veriry_desc == '运营商' && e.is_varify == 0 && e.is_true == 2) { // 排除如果运营商如果可以跳过
              this.total_rz = this.total_rz - 1;
              this.has_rz_total = this.has_rz_total + 1;
            } else if (e.veriry_desc == '运营商' && e.is_true == 2 && e.is_varify == 1 && e.is_display == 1) {
              this.has_rz_total = this.has_rz_total + 1;
            }
          });
        });

      this.isRest = sessionStorage.getItem('restRZ');
      if (sessionStorage.getItem('restRZ')) {
        sassSearchBanksList({userid: this.tk.userid})
          .then(res => {
            if (res.data.code == 200) {
              res.data.data.some((elem, index) => {
                if (elem.is_default == 1) {
                  this.holdBankPer = elem.name;
                  this.holdBankIdCard = elem.idcard;
                  this.BankId = elem.bank_card;
                  this.bankName = elem.bank_name;
                }
              })
            } else {
              this.$notify({
                type: 'danger',
                message: res.data.msg,
              });
            }
          })
          .catch(err => {
            if (err.toString().indexOf('timeout') != -1) {
              this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
            }
          })
      }
    },
    methods: {
      getLoan() {
        // 提交银行卡信息
        if (this.BankId != "" && (this.bankName != "" && this.bankName != null)) {
          // let data = {userid:this.tk.userid,bankCard:this.BankId,bankID:this.bankID,accountSupport:this.accountSupport,cardSupport:this.cardSupport,abbreviation:this.abbreviation};
          let data = {userid: this.tk.userid, bankCard: this.BankId, bankID: this.bankID};
          this.$store.commit('edit', true);//打开全局的loading
          postBanks(data)
            .then(res => {
              this.$store.commit('edit', false);//关闭全局的loading
              if (res.data.code == 200) {
                // this.$notify({type: 'success', message: this.$t('message.add_success')});
                setTimeout(() => {
                  this.$router.push({path: '/home'});
                }, 400)
              } else if (res.data.code == 202) {
                this.$notify({type: 'danger', message: res.data.msg});
                this.bankName = '';
                this.BankId = '';
                this.$store.commit('edit', false);//关闭全局的loading
              } else {
                this.$notify({type: 'danger', message: this.$t('message.jiancha')});
                this.$store.commit('edit', false);//关闭全局的loading
              }
            })
            .catch(err => {
              this.$store.commit('edit', false);//关闭全局的loading
              if (err.toString().indexOf('timeout') != -1) {
                this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
              }
            })
        } else {
          this.$notify({type: 'danger', message: this.$t('message.jiancha')});
        }
      },
      showModel(a) {
        this.show = true;
      },
      //关闭选择框
      onCancel() {
        this.show = false;
      },
      //选择框滚动时，表单内的值变化
      // onChange(picker, value, index) {
      //   this.bankName = this.banksList[index];
      // },
      //确定选择的值
      onConfirm(value, index) {
        let abbrev = this.banksList[index];
        this.bankName = this.banksList[index];
        this.temp.forEach((elem, index) => {
          if (elem.abbreviation == abbrev) {
            this.bankID = elem.bankID;
            this.accountSupport = elem.accountSupport;
            this.cardSupport = elem.cardSupport;
            this.abbreviation = elem.abbreviation;
          }
        });
        this.show = false;
      },
      goBack() {
        this.$router.push({path: '/perInfoHome/Social', query: {orderid: this.$route.query.orderid}})
      }
    }
  }
</script>

<style scoped lang="scss">
  .btns {
    @include defaultBtn;
    margin: 1.2rem 0 0.2rem;
  }

  /deep/ .van-cell.van-field {
    border-radius: 8px !important;
    border: 1px solid #cccccc !important;
  }

  /deep/ .cloumns-img {
    /*width: 80px!important;*/
    vertical-align: sub;
    margin-right: 10px;
    height: 23px !important;
  }

  .container {
    padding: 1.6rem 15px 0.3rem;

    .circle {
      width: 0.19rem;
      height: 0.19rem;
      background-color: #D5D5D5;
      border-radius: 0.19rem;
      display: inline-block;
      margin-right: 5px;
    }

    .circle1 {
      width: 0.53rem;
      height: 0.53rem;
      background: $color;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      line-height: 0.53rem;
    }

    .scsf {
      & :nth-child(1) {
        font-size: 0.53rem;
        font-weight: 600;
        color: $color;
        margin: 0.36rem 0 0.3rem;
      }

      & :nth-child(2) {
        font-size: 0.37rem;
        font-weight: 300;
        color: #878686;
      }
    }

    .form_item {
      margin-bottom: 0.36rem;

      .form_label {
        color: #000000;
        font-size: 0.45rem;
        font-weight: 500;
        margin-bottom: 0.27rem;

        span {
          color: #FF0300;
          margin-right: 3px;
        }
      }
    }

    .tips {
      color: #B9B9B9;
      font-size: 0.33rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/loanRecord/personInfo/banks.vue